import moment from "moment-timezone";
import { processUnavailableBlocks, type UnavailableBlock } from "./calculateUnavailableEvents";

const LEVEL_KEYS = ["level1", "level2", "level3", "level4"] as const;

const getId = (value: any) => value?.id ?? value;

export const canAssignUnassignedShift = (shift: any, user: any) => {
    if (!shift || !user?.id) return false;
    if (Number(shift?.slots ?? 1) <= 0) return false;

    const firstSection = shift?.sections?.[0];
    if (!firstSection) return false;

    const jobId = getId(firstSection?.job);
    if (jobId && !user?.jobs?.some((job: any) => job?.jobId === jobId)) return false;

    const locationId = getId(firstSection?.location);
    if (locationId && !user?.locations?.some((location: any) => location?.locationId === locationId)) return false;

    return LEVEL_KEYS.every((level) => {
        const shiftLevelId = getId(firstSection?.[level]);
        if (!shiftLevelId) return true;
        return getId(user?.[level]) === shiftLevelId;
    });
};

// Mirrors the event form interval validation: all-day unavailability blocks the day, otherwise check for overlap
export const isUserAvailableForShift = (user: any, startDate: moment.MomentInput, endDate: moment.MomentInput) => {
    const shiftStart = moment(startDate);
    let shiftEnd = moment(endDate);
    if (shiftEnd.isSameOrBefore(shiftStart, "seconds")) shiftEnd = shiftEnd.clone().add(1, "day");

    const blocks: UnavailableBlock[] = processUnavailableBlocks(user?.intervals || []);

    return !blocks.some((block) => {
        const blockStart = moment(block.startDate);
        if (block.allDay) return blockStart.isSame(shiftStart, "date");

        let blockEnd = moment(block.endDate);
        if (blockEnd.isSameOrBefore(blockStart, "seconds")) blockEnd = blockEnd.clone().add(1, "day");

        return shiftStart.isBefore(blockEnd, "seconds") && shiftEnd.isAfter(blockStart, "seconds");
    });
};
